/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import { Col, Row } from "components/Grid";
import { Label } from "components/Form";
import Layout from "components/Layout/index";
import StepNavigation from "components/StepNavigation";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer } from 'components/Button';
import BrokingSummary from "components/BrokingSummary";
import ClaimsSummary from 'components/ClaimsSummary';
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import CheckBox from "components/Form/CheckBox";
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { Title, ButtonContent } from "./styles";
import RenderButtons from 'components/RenderButtons';
import { useHeaderNbi, useListContactsByType } from 'services/QuoteService'; 
import { usePaymentConfigurationForm, useSendPaymantPackToInsurerAndClientLegacy} from 'services/PaymentPackService'

export default function SendPaymentPackInsurerClient(props) {
  const [summary, setSummary] = useState({});
  const authContext = useContext(GlobalAuthContext);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItems2, setSelectedItems2] = useState([]);
  const [selectedExternalBrokers, setSelectedExternalBrokers] = useState([]);
  const [selectedThirdParties, setSelectedThirdParties] = useState([]);
  const [insurers, setInsurers] = useState([]);
  const [historymsg, setHistorymsg] = useState([]);
  const [client, setClient] = useState([]);
  const [externalBrokers, setExternalBrokers] = useState([]);
  const [thirdParties, setThirdParties] = useState([]);
  const [endorsmentType, setEndorsmentType] = useState("");
  const [statusEndorsement, setStatusEndorsement] = useState({
    title: "Send Payment Pack",
    route: "",
  });
  const [isClaims, setIsClaims] = useState(false);

  const formik = useRef(null);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: usePaymentConfigurationFormData,
    loading: usePaymentConfigurationFormLoading,
    error: usePaymentConfigurationFormError,
    status: usePaymentConfigurationFormStatus,
    request: usePaymentConfigurationFormRequest,
  } = usePaymentConfigurationForm(props.match.params.idOperation);

  const {
    data: useListContactsByTypeData,
    loading: useListContactsByTypeLoading,
    error: useListContactsByTypeError,
    status: useListContactsByTypeStatus,
    request: useListContactsByTypeRequest,
  } = useListContactsByType('insurer', props.match.params.idOperation);

  const {
    data: useSendPaymantPackToInsurerAndClientData,
    loading: useSendPaymantPackToInsurerAndClientLoading,
    error: useSendPaymantPackToInsurerAndClientError,
    status: useSendPaymantPackToInsurerAndClientStatus,
    request: useSendPaymantPackToInsurerAndClientRequest,
  } = useSendPaymantPackToInsurerAndClientLegacy();


  useEffect(() => {
    if (useHeaderNbiLoading || usePaymentConfigurationFormLoading || useListContactsByTypeLoading || useSendPaymantPackToInsurerAndClientLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, usePaymentConfigurationFormLoading, useListContactsByTypeLoading, useSendPaymantPackToInsurerAndClientLoading]);

  const validation = () => {
    if (selectedItems.length <= 0 || selectedItems2.length <= 0) {
      return false;
    } else {
      return true;
    }
  }

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
      setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        setHistorymsg(data.ret_value.historical);
        setEndorsmentType(data.ret_value.endorsmentType)
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function handleSend() {
    let valid = validation();
    if (valid != true) {
      mc.error('Please fill in all required fields.');
      return
    }

    fitinsur.setAuthToken(authContext.token);
    let insuresContacts = [];

    insurers.forEach(x => {
      insuresContacts.push({
        idPersonInsurer: x.idPersonInsurer,
        contacts: []
      })
    })

    selectedItems.map(selectedInsurer => {
      let insurer = insuresContacts.find(e => e.idPersonInsurer == selectedInsurer.idPersonInsurer);
      insurer.contacts.push({ idContact: selectedInsurer.idContact, email: selectedInsurer.email });
    })

    let clientContacts = []
    selectedItems2.map(x => {
      clientContacts.push({ idContact: x.idContact, email: x.email });
    })


    let externalBrokersContacts = [];
    externalBrokers.map(x => {
      externalBrokersContacts.push({
        idPersonInsurer: x.idPersonInsurer,
        contacts: []
      })
    })

    selectedExternalBrokers.map(selectedInsurer => {
      let insurer = externalBrokersContacts.find(e => e.idPersonInsurer == selectedInsurer.idPersonInsurer);
      insurer.contacts.push({ idContact: selectedInsurer.idContact, email: selectedInsurer.email });
    })

    let thirdPartyContacts = [];
    thirdParties.map(x => {
      thirdPartyContacts.push({
        idPersonInsurer: x.idPersonInsurer,
        contacts: []
      })
    })

    selectedThirdParties.map(selectedInsurer => {
      let insurer = thirdPartyContacts.find(e => e.idPersonInsurer == selectedInsurer.idPersonInsurer);
      insurer.contacts.push({ idContact: selectedInsurer.idContact, email: selectedInsurer.email });
    })

    let body = {
      idOperation: props.match.params.idOperation,
      paymentPackMessage: formik.current.values.paymentPackMessage,
      insurers: insuresContacts,
      client: clientContacts,
      externalBrokers: externalBrokersContacts,
      thirdPartys: thirdPartyContacts
    };

    useSendPaymantPackToInsurerAndClientRequest({...body}).then(({data}) => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }

        return isClaims ? history.push('/claims') : history.push('/policies');
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  }

  function handleSelectInsurer(e, insurer) {
    const contact = { idPersonInsurer: insurer.idPersonInsurer, idContact: e.idContact, email: e.email };

    const alreadySelected = selectedItems.findIndex((item) => item.email === contact.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems.filter((item) => item.email !== contact.email);
      setSelectedItems(filteredItems);
    } else {
      let list = [...selectedItems];
      list.push(contact);
      setSelectedItems([...list]);
      console.log("list de contactos", selectedItems);
    };
  };

  function handleSelectExternalBroker(e, insurer) {
    const contact = { idPersonInsurer: insurer.idPersonInsurer, idContact: e.idContact, email: e.email };

    const alreadySelected = selectedExternalBrokers.findIndex((item) => item.email === contact.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedExternalBrokers.filter((item) => item.email !== contact.email);
      setSelectedExternalBrokers(filteredItems);
    } else {
      let list = [...selectedExternalBrokers];
      list.push(contact);
      setSelectedExternalBrokers([...list]);
    };
  };

  function handleSelectClient(e) {
    const contact = { idContact: e.idContact, email: e.email };

    const alreadySelected = selectedItems2.findIndex((item) => item.email === contact.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems2.filter((item) => item.email !== contact.email);
      setSelectedItems2(filteredItems);
    } else {
      console.log(selectedItems)
      let list = [...selectedItems2];
      list.push(contact);
      setSelectedItems2([...list]);
    };
  };

  function handleSelectThirdParty(e, insurer) {
    const contact = { idPersonInsurer: insurer.idPersonInsurer, idContact: e.idContact, email: e.email };

    const alreadySelected = selectedThirdParties.findIndex((item) => item.email === contact.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedThirdParties.filter((item) => item.email !== contact.email);
      setSelectedThirdParties(filteredItems);
    } else {
      let list = [...selectedThirdParties];
      list.push(contact);
      setSelectedThirdParties([...list]);
      console.log("list de contactos", selectedThirdParties);
    };
  };

  function listContacts(idContactDepartment) {
    useListContactsByTypeRequest(null, {idContactDepartment: idContactDepartment}, null, `/quote/insurer/list-contacts/${props.match.params.idOperation}?`).then(({data}) => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        } 
        
        const insurers = data.ret_value?.sort((a, b) => String(a?.nmInsurer).localeCompare(String(b?.nmInsurer))) || [];
        setInsurers(insurers);
      })
      .catch((error) => {
        mc.error("There was an error processing your request. Please try again later");
        console.error('fitPostListContact - Error:', error);
      });
  };

  function listContactsClients(idContactDepartment) {
    useListContactsByTypeRequest(null, {idContactDepartment: idContactDepartment}, null, `/quote/client/list-contacts/${props.match.params.idOperation}?`).then(({data}) => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        setClient(data.ret_value);
      })
      .catch((error) => {
        mc.error("There was an error processing your request. Please try again later");
        console.error('fitPostListContact - Error:', error);
      });
  };


  function listExternalContacts(idContactDepartment) {
    useListContactsByTypeRequest(null, {idContactDepartment: idContactDepartment}, null, `/quote/external/list-contacts/${props.match.params.idOperation}?`).then(({data}) => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        setExternalBrokers(data.ret_value);
      })
      .catch((error) => {
        mc.error("There was an error processing your request. Please try again later");
        console.error('fitPostListContact - Error:', error);
      });
  };

  function listThirdPartiesContacts(idContactDepartment) {
    useListContactsByTypeRequest(null, {idContactDepartment: idContactDepartment}, null, `/quote/third-party/list-contacts/${props.match.params.idOperation}?`).then(({data}) => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        setThirdParties(data.ret_value);
      })
      .catch((error) => {
        mc.error("There was an error processing your request. Please try again later");
        console.error('fitPostListContact - Error:', error);
      });
  };

  function getPaymentConfigurationForm() {
    usePaymentConfigurationFormRequest().then(({data: response}) => {
        if (response.ret_code != 200) {
          mc.error(response.ret_msg_details);
          history.goBack();
          return;
        }
        setIsClaims(response.ret_value.isClaims);
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${getPaymentConfigurationForm.name}\n` + error);
      });
  }

  const renderExternalBrokerList = externalBrokers.length ? externalBrokers.map((externalBroker) => (
    <>
      <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
        <Title>
          {externalBroker.nmInsurer}
        </Title>
      </Row>

      {externalBroker.contacts.length ? externalBroker.contacts.map((contact) => (
        <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
          <Col md={4} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <label>
              <CheckBox
                onChange={() => { handleSelectExternalBroker(contact, externalBroker) }}
                checked={selectedExternalBrokers.find((item) => item.email === contact.email) ? true : false}
              />
            </label>
            <Label>{contact.legalEntity}</Label>
          </Col>
          <Col md={3} style={{ flexDirection: "row", display: "flex" }}>
            <Label>
              {contact.nameContact}
            </Label>
          </Col>
          <Col md={2} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <Label>{contact.personContactDepartment}</Label>
          </Col>
          <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <Label>{contact.email}</Label>
          </Col>
        </Row>
        ))
        :
        (
          <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
            <Label>
              No results found.
            </Label>
          </Row>
        )}  
    </>
  )) 
  :
  (
    <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
      <Label>
        No results found.
      </Label>
    </Row>
  );

  const renderThirdParty = thirdParties.length ? thirdParties.map((thirdParties) => (
    <>
      <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
        <Title>
          {thirdParties.nmInsurer}
        </Title>
      </Row>

      {thirdParties.contacts.length ? thirdParties.contacts.map((contact) => (
        <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
          <Col md={4} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <label>
              <CheckBox
                onChange={() => { handleSelectThirdParty(contact, thirdParties) }}
                checked={selectedThirdParties.find((item) => item.email === contact.email) ? true : false}
              />
            </label>
            <Label>{contact.legalEntity}</Label>
          </Col>
          <Col md={3} style={{ flexDirection: "row", display: "flex" }}>
            <Label>
              {contact.nameContact}
            </Label>
          </Col>
          <Col md={2} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <Label>{contact.personContactDepartment}</Label>
          </Col>
          <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <Label>{contact.email}</Label>
          </Col>
        </Row>
      ))
      :
      (
        <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
          <Label>
            No results found.
          </Label>
        </Row>
      )}
    </>
  ))
  :
  (
    <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
      <Label>
        No results found.
      </Label>
    </Row>
  );

  const listItems = insurers.length ? insurers.map((insurer) => (
    <>
      <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
        <Title>
          {insurer.insurerFirstName}
        </Title>
      </Row>

      {insurer.contacts.length ? insurer.contacts.map((contact) => (
        <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
          <Col md={4} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <label>
              <CheckBox
                onChange={() => { handleSelectInsurer(contact, insurer) }}
                checked={selectedItems.find((item) => item.email === contact.email) ? true : false}
              />
            </label>
            <Label>{contact.legalEntity}</Label>
          </Col>
          <Col md={3} style={{ flexDirection: "row", display: "flex" }}>
            <Label>
              {contact.nameContact}
            </Label>
          </Col>
          <Col md={2} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <Label>{contact.personContactDepartment}</Label>
          </Col>
          <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <Label>{contact.email}</Label>
          </Col>
        </Row>
      ))
      :
      (
        <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
          <Label>
            No results found.
          </Label>
        </Row>
      )}
    </>
  ))
  :
  (
    <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
      <Label>
        No results found.
      </Label>
    </Row>
  );

  const listItems2 = client.length ? client.map((client) => (
    <>
      <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px", marginBottom: '5px' }}>
        <Col md={4} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
          <label>
            <CheckBox
              onChange={() => { handleSelectClient(client) }}
              checked={selectedItems2.find((item) => item.email === client.email) ? true : false}
              disabled={client.existContact ? true : false}
            />
          </label>
          <Label>{client.legalEntity}</Label>
        </Col>
        <Col md={3} style={{ flexDirection: "row", display: "flex" }}>
          <Label>
            {client.nameContact}
          </Label>
        </Col>
        <Col md={2} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
          <Label>
            {client.personContactDepartment}
          </Label>
        </Col>
        <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
          <Label>{client.email}</Label>
        </Col>
      </Row>
    </>
  ))
  : 
  (
    <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
      <Label>
        No results found.
      </Label>
    </Row>
  );

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    handleSummary();
    listContacts();
    listContactsClients();
    listExternalContacts();
    listThirdPartiesContacts();
    getPaymentConfigurationForm();
  }, [])

  useEffect(() => {
    if (endorsmentType === 'pre-agreed') {
      setStatusEndorsement({
        title: "ANNIVERSARY: PREMIUM PRE AGREED / SEND PAYMENT PACK",
        route: ''
      })
    } else if (endorsmentType === 'not-pre-agreed') {
      setStatusEndorsement({
        title: "ANNIVERSARY: PREMIUM NOT PRE AGREED / SEND PAYMENT PACK",
        route: ''
      })
    } else if (endorsmentType === 'off-risk') {
      return;
    } else if (endorsmentType === 'cancellation') {
      setStatusEndorsement({
        title: "ENDORSEMENT - CANCELLATION / SEND PAYMENT PACK",
        route: ''
      })
    } else if (endorsmentType === 'market-changes') {
      setStatusEndorsement({
        title: "RISK & MARKET CHANGES / SEND PAYMENT PACK",
        route: ''
      })
    }
  }, [endorsmentType])


  function handlePaymentConfiguration() {
    history.push(`/broking/payment-pack-configuration/${props.match.params.idOperation}`)
  };

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >
      {isClaims ? <ClaimsSummary stage={3} idOperation={props.match?.params?.idOperation} />
      : <>
        <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
        <BrokingSummary data={summary} />
      </>}

      <ContentCard
        title={statusEndorsement.title}
        icon
        filterContact
        handleFilterContact={(idContactDepartment) => {
          listContacts(idContactDepartment);
          listContactsClients(idContactDepartment);
          listExternalContacts(idContactDepartment);
          listThirdPartiesContacts(idContactDepartment);
        }}

        info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
        <Formik
          innerRef={formik}
          initialValues={{ paymentPackMessage: '' }}
          onSubmit={handleSend}
        >
          {formikProps => (
            <Form>
              <>
                <Title>TO - CLIENT</Title>
                {listItems2}
              </>
              <br></br>
              <>
                <Title>TO - INSURERS</Title>
                {listItems}
              </>
              <br></br>
              <>
                <Title>TO - EXTERNAL BROKER</Title>
                {renderExternalBrokerList}
              </>
              <br></br>
              <>
                <Title>TO - 3rd PARTY</Title>
                {renderThirdParty}
              </>
              <Field
                label={'Payment Pack Message'}
                name={'paymentPackMessage'}
                value={formikProps.values.paymentPackMessage}
                onChange={(e) => formikProps?.setFieldValue('paymentPackMessage', e)}
                component={TextField}
              />
              <ButtonContainer>
                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                <RenderButtons idOperation={props.match?.params?.idOperation}>
                  <ButtonContent>
                    <>
                      <Button
                        style={{ marginLeft: "30px", marginTop: "5px" }}
                        third
                        id="btnRegeneratePaymentPack"
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handlePaymentConfiguration() }}>
                        REGENERATE PAYMENT PACK
                      </Button>

                      <Button
                        style={{ marginLeft: "30px", marginTop: "5px" }}
                        primary
                        type="submit"
                        id="btnSubmit"
                      >
                        SEND PAYMENT PACK
                      </Button>
                    </>
                  </ButtonContent>
                </RenderButtons>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
    </Layout>
  );
}
